/**
 * @generated SignedSource<<7501217c2b5eee4d26565c40499071ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectIndicator_project$data = {
  readonly name: string | null;
  readonly companyProjectId: number | null;
  readonly customProjectId: string | null;
  readonly projectColor: string | null;
  readonly " $fragmentType": "ProjectIndicator_project";
};
export type ProjectIndicator_project$key = {
  readonly " $data"?: ProjectIndicator_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectIndicator_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectIndicator_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "c4adcd44ebb212f53d9cb6d6ef78adb2";

export default node;
